import { events } from './EventEmitter';
import {
  type Callback,
  type GenericRouterInterface,
  type NavigateOptions,
  type PrefetchOptions,
  type ReadonlyURLSearchParams,
} from './types/propsType';

export const genericRouter: GenericRouterInterface = {
  back: function (): void {
    return;
  },
  forward: function (): void {
    return;
  },
  refresh: function (): void {
    return;
  },
  push: function (_href: string, _options?: NavigateOptions | undefined): void {
    return;
  },
  replace: function (_href: string, _options?: NavigateOptions | undefined): void {
    return;
  },
  prefetch: function (_href: string, _options?: PrefetchOptions | undefined): void {
    return;
  },
  events: {
    on: (eventName: string, callback: Callback) => {
      events.on(eventName, callback);
    },
    off: (eventName: string, callback: Callback) => {
      events.on(eventName, callback);
    },
    emit(eventName, ...args) {
      events.emit(eventName, ...args);
    },
    setIsBlockRoute: (isBlocked: boolean) => {
      events.setIsBlockRoute(isBlocked);
    },
    setIsBackBlocked: (isBlocked: boolean) => {
      events.setIsBackBlocked(isBlocked);
    },
    getIsBlockRoute: () => events.getIsBlockRoute(),
    getIsBackBlocked: () => events.getIsBackBlocked(),
  },
}; // useRouter()

export const genericPathname = '/'; //usePathname()

export const genericSearchParams: ReadonlyURLSearchParams | null = null; // useSearchParams()

export const genericPathParams = null; // useParams()
